<h4 mat-dialog-title class="text-center">
	ANR Project Board
</h4>
<mat-dialog-content>
	<div class="text-center">
		<p class="mb-4">{{message}}</p>
		<img style="max-width:300px;" src="/assets/UCANR_rect.png" class="logo">
	</div>
</mat-dialog-content>
<mat-dialog-actions>
	<button 
		*ngIf="showMSLoginButton"
		style="box-sizing: border-box;"
		class="btn btn-primary btn-block btn-lg" 
		(click)="msLogIn()">
		<i class="fa fa-windows mr-2" aria-hidden="true"></i>Log in with Microsoft
	</button>
	<button 
		*ngIf="showOktaLoginButton"
		style="box-sizing: border-box;"
		class="btn btn-primary btn-block btn-lg" 
		(click)="oktaLogIn()">
		<img class="okta-img mr-2" src="/assets/okta-icon.svg"/>Log in with Okta
	</button>	
</mat-dialog-actions>